<template>
	<div>
		<Col span="8" style="padding-right:10px">
		<Select v-model="region.one" filterable @on-change="queryregion(region.one,1)">
			<Option v-for="(option, index) in list1" :value="option.id" :key="index">{{option.name}}</Option> 
		</Select>
		</Col>
		<Col span="8" style="padding-right:10px">
		<Select v-model="region.two" filterable  @on-change="queryregion(region.two,2)">
			<Option v-for="(option, index) in list2" :value="option.id" :key="index">{{option.name}}</Option>
		</Select>
		</Col>
		<Col span="8" style="padding-right:10px">
		<Select v-model="region.three" filterable @on-change="setRegion">
			<Option v-for="(option, index) in list3" :value="option.id" :key="index">{{option.name}}</Option>
		</Select>
		</Col>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data(){
			return {
				region: {
					one: '',
					two: '',
					three: ''
				},
				list1: [],
				list2: [],
				list3: [],
			}
		},
		props:["t"],
		methods:{
			setRegion(){
				
				this.$emit('setRegion',this.region.three)
			},
			queryregion(id,index){
				if(id==null || index ==null){
					return ;
				}
				console.log(this.t)
				if(this.t=="plat"){
				console.log(this.id)
					this.$emit('setRegion',id)
				}
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/region/junior',
				    data: {id:id},
					_this: _this,
					success: function(data) {
						_this.list3=[]
						_this.region.three=""
						console.log(data)
						if(index==0){
						    _this.list1 = data.list
						}
						if(index==1){
						    _this.list2 = data.list
							
						}
						if(index==2){
						    _this.list3 = data.list
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
		created() {
			let _this=this
			http.http({
			    //这里是你自己的请求方式、url和data参数
			    method: 'post',
			    url: http.url + '/region/queryByJmEmpId',
				data:{},
				_this: _this,
				success: function(data) {
					_this.list1=data.vo.oneRegions
					_this.list2=data.vo.twoRegions
					_this.list3=data.vo.threeRegions
					_this.region.one=_this.list1[0].id
					_this.region.two=_this.list2[0].id
					_this.region.three=_this.list3[0].id
					_this.$emit('setRegion',_this.region.three)
				}
			    //假设后台需要的是表单数据这里你就可以更改
			  })
			
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/comm/region.vue